import React, {Component} from 'react';
import {withRouter} from 'react-router-dom';
import AccountExpenseContainer from '../../../containers/account_expense_container';
import {Button, Form, Header, Icon, Popup} from 'semantic-ui-react';
import ReactTable from "react-table";
import Loader from '../../universal/loader';
import {BASE_URL, EXPENSE} from "../../../constants/app_routes";
import DayPickerInput from 'react-day-picker/DayPickerInput';
import {formatDate, parseDate} from 'react-day-picker/moment';
import moment from "moment";
import {handleFileDownload} from "../../../utils/download_file";
import DownloadingIntent from "../../universal/toast";

class ExpenseList extends Component {

    constructor(props) {
        super(props);
        this.state = {
            totalEstimate: 0,
            filterApplied: false,
            selectedIds:[],
            fromDate: undefined,
            toDate: undefined,
            dateFiltered: false,
        }
    }

    componentWillMount() {
        this.props.getExpenseList();
    }

    handleView = (id) => {
        this.props.history.push(`${EXPENSE}/view/${id}`);
    };

    handleFilterSelection() {
        this.setState({dateFiltered: true,selectedIds:[]});
        if(this.state.fromDate && this.state.toDate){
            this.props.getExpenseList(this.state.fromDate, this.state.toDate)
        }
    }

    handleSelection = (id) => {
        let selectedId = this.state.selectedIds;
        const index = selectedId.indexOf(id);
        if( index === -1){
            selectedId.push(id);
        }
        else {
            selectedId.splice(index,1)
        }
        this.setState({selectedIds:selectedId});
    };

    handleDownload = async () => {
        this.setState({isDownloading:true,showDownload:true});
        let URL = BASE_URL+"/export/expense";
        let fileName = "Expenses List.xlsx";
        if(this.state.selectedIds.length < 1 && this.state.dateFiltered && this.state.fromDate && this.state.toDate){
            fileName = "Expenses List -"+moment(this.state.fromDate).format("YYYY-MM-DD")+"-"+moment(this.state.toDate).format("YYYY-MM-DD")+" .xlsx";
            URL = BASE_URL+"/export/expense?start_date="+this.state.fromDate+"&end_date="+this.state.toDate;
        }
        if(this.state.selectedIds.length > 0){
            URL = BASE_URL+"/export/expense?ids=["+this.state.selectedIds+"]";
        }
        await handleFileDownload(URL,fileName,'application/xlsx');
        this.setState({isDownloading:false});
    };

    render() {
        const columns = [{
            Header: 'Select',
            id:'selection',
            accessor:'id',
            className: 'center-aligned micro-width',
            headerClassName:'micro-width',
            filterable: false,
            Cell: ({value}) => (
                <div>
                    <input type="checkbox" onClick={(e) => {this.handleSelection(value)}} />
                </div>
            ),
        },{
            Header: 'Date',
            accessor: 'date',
            className: 'center-aligned',
            filterable: true,
        }, {
            Header: 'Expense Id',
            accessor: 'expense_number',
            className: 'center-aligned',
            filterable: true
        }, {
            Header: 'Clerk Name',
            accessor: 'clerk_profile_name',
            className: 'max-width',
            headerClassName: 'max-width',
            filterable: true
        }, {
            Header: 'Total Expense',
            accessor: 'total_amount',
            className:'format-bold',
            filterable: true,
            Cell: ({value}) => (
                <div>
                    <span>£ {value}</span>
                </div>
            ),
        },{
            Header: 'Expense Status',
            className: 'center-aligned',
            accessor: 'status',
            Cell: ({value}) => (
                <div>
                    <Button size='mini' fluid><span className="format-capitalize">{value}</span></Button>
                </div>
            ),
            filterable: true
        }, {
            Header: 'Action',
            id: 'edit',
            headerClassName:'mini-width',
            className: 'center-aligned mini-width',
            accessor: 'id',
            sortable:false,
            Cell: ({value}) => (
                <div>
                    <Button basic compact icon positive size='mini' onClick={(e) => this.handleView(value)}><Icon
                        name='eye'/>View</Button>
                </div>
            )
        }];
        return (<div style={{minHeight: '450px'}} className="pad-bottom">
            <div style={{position: 'absolute',top:'-100px',right:'0'}}>
                <Popup
                    trigger={<Button icon='filter' labelPosition='right' content='Date'/>}
                    content={<div>
                        <div><Header content="Filter Expenses By Date"/><Form><span><b>From: </b><DayPickerInput
                            placeholder="From"
                            dayPickerProps={{
                                todayButton: 'Today',
                            }}
                            format="DD-MM-YYYY"
                            value={moment().format("DD-MM-YYYY")}
                            formatDate={formatDate}
                            parseDate={parseDate}
                            onDayChange={day => {day ? this.setState({fromDate: day,toDate:day}): this.setState({fromDate:undefined})}}/></span>
                            <span><b>To: </b><DayPickerInput
                                placeholder="To"
                                format="DD-MM-YYYY"
                                formatDate={formatDate}
                                value={this.state.toDate}
                                parseDate={parseDate}
                                dayPickerProps={{
                                    disabledDays: {before: this.state.fromDate},
                                    todayButton: 'Today',
                                    firstDayOfWeek : 1,
                                }} onDayChange={day => {day ?this.setState({toDate: day}): this.setState({endDate:undefined}) }}/></span></Form></div>
                        <br/>
                        <div style={{width:'100%'}} className="right-aligned">
                        <Button content="Get Expenses" primary
                                onClick={() => this.handleFilterSelection()}/></div>
                         </div>}
                    on='click'
                    position="bottom left"
                    flowing
                    hideOnScroll
                    wide
                />
            </div>
            <div style={{position:'absolute',top:'-100px',right:'150px'}}>
                <Button content="Export Expenses" primary onClick={this.handleDownload}/>
            </div>
            <div className="pad-bottom right-aligned">
                <span>No. selected Items : </span>
                <span
                className="format-bold"> {this.state.selectedIds.length}</span><span className="pad-left">
                </span>
            </div>
            <div>
                {this.state.dateFiltered &&
                <div className="date-range-info"><span>Showing Expenses from :</span><span
                    className="format-bold">{moment(this.state.fromDate).format("LL").toString()}</span><span> to </span><span
                    className="format-bold">{moment(this.state.toDate).format("LL").toString()}</span>
                </div>}
            </div>
            {!this.props.isFetching && <ReactTable
                data={this.props.expenses}
                columns={columns}
                defaultFilterMethod={(filter, row, column) => {
                    const id = filter.pivotId || filter.id;
                    return row[id] !== undefined ? String(row[id]).toUpperCase().startsWith(filter.value.toUpperCase()) : true
                }}
                minRows={11}
                defaultPageSize={10000}
                showPagination={false}
                style={{
                    height: '550px'
                }}
                noDataText="No Expenses found"
            />}
            {this.props.isFetching && <Loader/>}
            {this.state.showDownload && <DownloadingIntent isDownloading={this.state.isDownloading}/>}
        </div>)
    }
}

export default AccountExpenseContainer(withRouter(ExpenseList));


// WEBPACK FOOTER //
// ./src/views/accounts/expense/expenses.js